var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardTable',{attrs:{"loading":_vm.loadingServices,"header":"Past Services","tableHeaders":_vm.headers,"tableData":_vm.pastServicesTableData}})
}
var staticRenderFns = []

export { render, staticRenderFns }